import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { ExamCallService } from '../../../../../../services/exam-call/exam-call.service';
import { ShiftService } from '../../../../../../services/shifts/shift.service';
import { TranslationService } from '../../../../../../services/translation/translation.service';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { SweetAlertService } from '../../../../../../services/sweet-alert/sweet-alert.service';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { MY_FORMATS } from '../../../../../../const/date-format';

@Component({
    selector: 'fuse-bulk-edit-exam-boards',
    templateUrl: './bulk-edit-exam-boards.component.html',
    styleUrls: ['./bulk-edit-exam-boards.component.scss'],
    providers: [
        { provide: MAT_DATE_LOCALE, useValue: 'es-AR' },
        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    ]
})
export class BulkEditExamBoardsComponent implements OnInit {
    @BlockUI('bulk-edit-section') blockUI: NgBlockUI;

    schoolYearId: number;
    isLoaded: boolean = false;

    shifts: any[] = [];
    selectedShiftId: number;

    bulkData: any = {
        Calls: [],
        Rows: []
    };

    filteredRows: any[] = [];

    pastelPalette: string[] = [
        '#075099ff', // Azul
        '#f8e112ff', // Amarillo
        '#388E3C', // Verde
        '#F57C00', // Naranja
        '#03A9F4', // Celeste
        '#f10ae6ff', // Rosado
        '#7B1FA2'  // Violeta
    ];

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private location: Location,
        private examCallService: ExamCallService,
        private shiftService: ShiftService,
        private translationService: TranslationService,
        private sweetAlertService: SweetAlertService
    ) {
        this.route.params.subscribe(params => {
            this.schoolYearId = +params['schoolYearId'];
        });
    }

    ngOnInit() {
        this.loadShifts();
    }

    loadShifts() {
        this.shiftService.getAll().subscribe(res => {
            this.shifts = res;
        });
    }

    loadBulkData() {
        this.blockUI.start(this.translationService.loading);
        this.examCallService.getBulkEditData(this.schoolYearId).subscribe(res => {
            if (res.ResultCode === 1) {
                this.bulkData = res.Result;
                // Store initial values for change tracking
                this.bulkData.Rows.forEach(row => {
                    Object.keys(row.CallData).forEach(callId => {
                        const cd = row.CallData[callId];
                        cd.OriginalDate = cd.Date;
                        cd.OriginalTime = cd.Time;
                    });
                });
                this.isLoaded = true;
                this.filterRows();
            }
            this.blockUI.stop();
        }, () => this.blockUI.stop());
    }

    onShiftChange(shiftId: number) {
        this.selectedShiftId = shiftId;
        if (!this.isLoaded) {
            this.loadBulkData();
        } else {
            this.filterRows();
        }
    }

    filterRows() {
        if (!this.selectedShiftId) {
            this.filteredRows = this.bulkData.Rows;
        } else {
            this.filteredRows = this.bulkData.Rows.filter(r => r.ShiftId === this.selectedShiftId);
        }
    }

    save() {
        this.blockUI.start(this.translationService.loading);
        const saveData = {
            Rows: this.bulkData.Rows,
            SchoolYearId: this.schoolYearId
        };

        this.examCallService.saveBulkEdit(saveData).subscribe(res => {
            this.blockUI.stop();
            if (res.ResultCode === 1) {
                this.sweetAlertService.success(this.translationService.success, res.ResultMsg, () => {
                    this.goBack();
                });
            } else {
                this.sweetAlertService.error("Error", res.ResultMsg, null);
            }
        }, () => this.blockUI.stop());
    }

    isModified(callData: any): boolean {
        if (!callData) return false;

        const dateChanged = this.normalizeDate(callData.Date) !== this.normalizeDate(callData.OriginalDate);
        const timeChanged = (callData.Time || '') !== (callData.OriginalTime || '');

        return dateChanged || timeChanged;
    }

    private normalizeDate(date: any): string {
        if (!date) return '';
        if (date && date._isAMomentObject) return date.format('YYYY-MM-DD');
        if (date instanceof Date) return date.toISOString().split('T')[0];
        if (typeof date === 'string') return date.split('T')[0];
        return '';
    }

    getDateColor(date: any, callId: number): string {
        const dateStr = this.normalizeDate(date);
        if (!dateStr) return '';

        let hash = 0;
        // Using date and callId to determine color index within the 7 colors
        const str = dateStr + "_" + callId;
        for (let i = 0; i < str.length; i++) {
            hash = ((hash << 5) - hash) + str.charCodeAt(i);
            hash |= 0;
        }

        // Ensure color distribution across our 7 colors
        const index = Math.abs(hash) % this.pastelPalette.length;
        return this.pastelPalette[index];
    }

    goBack() {
        this.location.back();
    }
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/management/exam-calls/components/bulk-edit-exam-boards/bulk-edit-exam-boards.component.ts